interface RequestHandlerProps {
  method: string
  url: string
  headers?: HeadersInit
  params?: Record<string, string>
  body?: string
  timeout?: number // milliseconds
}

// All API requests should be handled here, so we have consistent error handling
export const RequestHandler = async (props: RequestHandlerProps): Promise<Promise<Response> | Error> => {
  const { method, url, headers, params, body, timeout = 30000 } = props
  const defaultHeaders = {
    'Content-Type': 'application/json',
  }

  const urlObject = new URL(url)
  if (params) {
    Object.keys(params).forEach(key => urlObject.searchParams.append(key, params[key]))
  }

  let request: RequestInit
  if (method === 'GET') {
    request = {
      headers: Object.assign({}, defaultHeaders, headers),
    }
  } else {
    request = {
      method,
      headers: Object.assign({}, defaultHeaders, headers),
      body,
    }
  }

  return await Promise.race([
    fetch(urlObject.href, request),
    new Promise<Error>((_, reject) => setTimeout(() => reject(new Error(`Timeout: ${url}`)), timeout)), // 30 seconds before timeout
  ])
}
